import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";
import { use } from "react";

const vendorSaleApi = createApi({
  reducerPath: "vendorSaleApi",
  baseQuery: authBaseQuery,
  tagTypes: ["vendorSales"],
  endpoints: (builder) => ({
    getVendorSalesInventory: builder.query({
      query: () => "/v1/sales/vendor_sales/inventory",
      transformResponse: (response) => response?.data,
      providesTags: ["vendorSales"],
    }),
    getAllVendorSalesPostLinks: builder.query({
      query: () => "/v1/get_all_vendor_sales_post_links",
    }),
    addPostStats: builder.mutation({
      query: (body) => ({
        url: "/v1/sales/vendor_sales/add_post_stats",
        method: "POST",
        body,
      }),
    }),
    addPostStatsOtherPlatform: builder.mutation({
      query: (body) => ({
        url: "/v1/sales/vendor_sales/add_post_stats_other_platforms",
        method: "POST",
        body,
      }),
    }),

    getAllVendorSalesPostLinksByVendorId: builder.query({
      query: (vendorCustomerId) =>
        `v1/sales/vendor_sales/get_all_vendor_sales_post_links?vendor_customer_id=${vendorCustomerId}`,
      transformResponse: (response) => response?.data,
    }),

    updateVendorSalesPostLinkById: builder.mutation({
      query: ({ id, body }) => ({
        url: `v1/sales/vendor_sales/vendor-post-link/${id}`,
        method: "PUT",
        body,
      }),
    }),

    getVendorInventory: builder.query({
      query: (id) => `v1/sales/vendor_sales/inventory?vendor_customer_id=${id}`,
    }),

    getVendorInventoryByIDData: builder.query({
      query: (id) => `v1/sales/vendor_sales/inventory/${id}`,
      transformErrorResponse: (response) => response?.data,
    }),

    addVendorInventory: builder.mutation({
      query: (payload) => ({
        url: "v1/sales/vendor_sales/inventory",
        method: "POST",
        body: payload,
      }),
    }),
    addVendorCampaignSales: builder.mutation({
      query: (payload) => ({
        url: "v1/sales/vendor_sales/add_vendor_campaign_sales",
        method: "POST",
        body: payload,
      }),
    }),

    getVendorSalesByShortCodes: builder.mutation({
      query: (data) => ({
        url: "v1/sales/vendor_sales/get_all_vendor_sales_post_links_by_short_code",
        method: "POST",
        body: data,
      }),
    }),

    addInstagramStory: builder.mutation({
      query: (payload) => ({
        url: "v1/sales/vendor_sales/add_instagram_story",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["VendorSales"],
    }),

    updateStatusUsingShortCode: builder.mutation({
      query: ({ body }) => ({
        url: `v1/sales/vendor_sales/update_status_using_short_code`,
        method: "PUT",
        body,
      }),
    }),
    updateVendorSales: builder.mutation({
      query: ({ body }) => ({
        url: `v1/sales/vendor_sales/multiple-update-sales-status
`,
        method: "PUT",
        body,
      }),
    }),
    updateVendorSaleInventory: builder.mutation({
      query: ({ id, body }) => ({
        url: `v1/sales/vendor_sales/inventory/${id}`,
        method: "PUT",
        body,
      }),
    }),

    vendorSaleBulkInventory: builder.mutation({
      query: ({ body }) => ({
        url: `v1/sales/vendor_sales/bulk_inventory`,
        method: "POST",
        body,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),

    updateVendorBulkInventory: builder.mutation({
      query: ({ id, body }) => ({
        url: `v1/sales/vendor_sales/bulk_inventory`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useGetVendorSalesInventoryQuery,
  useGetAllVendorSalesPostLinksQuery,
  useAddPostStatsMutation,
  useAddPostStatsOtherPlatformMutation,
  useGetAllVendorSalesPostLinksByVendorIdQuery,
  useUpdateVendorSalesPostLinkByIdMutation,
  useGetVendorInventoryQuery,
  useAddVendorInventoryMutation,
  useAddVendorCampaignSalesMutation,
  useGetVendorSalesByShortCodesMutation,
  useAddInstagramStoryMutation,
  useUpdateStatusUsingShortCodeMutation,
  useVendorSaleBulkInventoryMutation,
  useUpdateVendorSalesMutation,
  useUpdateVendorSaleInventoryMutation,
  useGetVendorInventoryByIDDataQuery,
  useUpdateVendorBulkInventoryMutation,
} = vendorSaleApi;

export default vendorSaleApi;
